import React, { useContext, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GlobalState } from '../store/GlobalState';
import { httpss } from '../utils/host';
import axios from 'axios';
import ReportDay from '../components/Reports/ReportDay';
import ReportWeek from '../components/Reports/ReportWeek';
import ReportMonth from '../components/Reports/ReportMonth';
import { IoReload } from "react-icons/io5";
import exportExcel from '../components/ExportExcel/exportToExcel';

export default function FanPageTable() {
  const { listPages  } = useContext(GlobalState);
  const pages = listPages.listPages[0] || [];

  const [selectedPageId, setSelectedPageId] = useState('');
  const [selectedPageData, setSelectedPageData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChangePage = (id) => {
    setSelectedPageId(id);
    setSearchParams({ pageId: id }); // cập nhật URL
  };

  useEffect(() => {
    const urlPageId = searchParams.get("pageId");
    if (pages.length > 0) {
      const validPage = pages.find((p) => p.id.toString() === urlPageId);
      if (urlPageId && validPage) {
        setSelectedPageId(urlPageId);
      } else {
        setSelectedPageId(pages[0].id);
        setSearchParams({ pageId: pages[0].id });
      }
    }
  }, [pages, searchParams]);
  

  
  // useEffect(() => {
  //   if(selectedPageId) {
  //     fetDataPage();
  //   }
  // }, [selectedPageId]);
  
  const handleExportExcel = async () => {
    const data = await fetDataPage(); // đợi lấy data
    if (data) {
      await exportExcel(data); // xuất data
    }
  };
  
  const fetDataPage = async () => {
    try {
      const res = await fetch(`${httpss}/apis_v1/user/pages_detail?pageId=${selectedPageId}`);
      const json = await res.json();
  
      if (Array.isArray(json)) {
        setSelectedPageData(json[0]);
        return json[0]; // Trả về dữ liệu để handleExportExcel dùng
      } else {
        console.error("Dữ liệu không phải mảng!");
        return null;
      }
    } catch (err) {
      console.error("Error loading selected page data:", err);
      return null;
    }
  };
  

  const selectedPage = pages.find(p => p.id === Number(selectedPageId));
  
  if (!selectedPageId) {
    return <div className="p-4">Đang tải fanpage...</div>;
  }
  
  return (
    <div className="p-4">
      {/* Dropdown chọn fanpage */}
      <div className="flex flex-wrap items-center gap-3 mb-4 p-4 bg-white rounded-xl shadow-sm border">
        <select
          value={selectedPageId || ''}
          onChange={(e) => handleChangePage(e.target.value)}
          className="border border-gray-300 rounded-lg px-4 py-2 outline-none focus:ring-2 focus:ring-sky-500 transition-all min-w-[200px]"
        >
          <option value="" disabled>-- Chọn Fanpage --</option>
          {pages.map(page => (
            <option key={page.id} value={page.id}>{page.name}</option>
          ))}
        </select>

        {selectedPage && (
          <img
            src={selectedPage.picture}
            alt="Avatar"
            className="w-10 h-10 rounded-full border object-cover"
          />
        )}

        <button
          onClick={handleExportExcel}
          className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg transition"
        >
          Xuất Excel
        </button>
      </div>

      {/* {selectedPage ? <ReportList selectedPage={selectedPage} selectedPageData={selectedPageData} /> : <p>Không có bài viết nào.</p>} */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ReportDay selectedPageId={selectedPageId}/>
          <ReportWeek selectedPageId={selectedPageId}/>
      </div>

      <div className="mt-4">
          <ReportMonth selectedPageId={selectedPageId}/>
      </div>
    </div>
  );
}
